// Keys the plain buttons report to Toolbar.Root; the menus and popovers
// export their own next to their component.
export const STICKY_NOTE_ID = 'sticky_note'
export const COMMENTS_ID = 'comments'
export const ESTIMATE_ID = 'estimate'
export const IMAGE_MODE_ID = 'image_mode'
export const SEO_MODE_ID = 'seo_mode'

// Menus and popovers open 6px above the bar (figma 86165:420742): the bar's
// own 6px padding plus this gap from the trigger.
export const MENU_OFFSET = 12
